import React from 'react';
import { high } from '../../contanst/pro_customer';
import '../../assets/css/product/customer.css'

const High = () => {
    return (
        <div className='pro_customer_Exhibition1'>
            {
                high.map((item, index) => {
                    return (
                        <div key={index}  >
                            <img src={item.pic} className='customer_img' alt='' />
                        </div>
                    )
                })
            }
        </div>
    );
}
 
export default High;
